module.exports = require("././angular-sanitize.js");


//////////////////
// WEBPACK FOOTER
// angular-sanitize (bower component)
// module id = 445
// module chunks = 0